
export const ServiceModules = {
    AUTH: process.env.NEXT_PUBLIC_AUTH_SERVICE || 'auth',
    JOB: process.env.NEXT_PUBLIC_JOBS_SERVICE || 'jobs',
    MAIN: process.env.NEXT_PUBLIC_MAIN_SERVICE || 'main',
    NOTIFICATION: process.env.NEXT_PUBLIC_NOTIFICATION_SERVICE || 'notification',
    ASSESSMENT: process.env.NEXT_PUBLIC_ASSESSMENT_SERVICE || 'assessment',
    WORKFLOW: process.env.NEXT_PUBLIC_WORKFLOW_SERVICE || 'workflow',
    CLIENT: process.env.NEXT_PUBLIC_CLIENT_SERVICE || 'client',
    HIRING: process.env.NEXT_PUBLIC_HIRING_SERVICE || 'hiring',
    QUEUE: 'queue',
    TALENT_POOL_ATS: process.env.NEXT_PUBLIC_TALENT_POOL_ATS_SERVICE || 'talent-pool-ats',
    AI: process.env.NEXT_PUBLIC_AI_SERVICE || 'ai',
    PAYMENT: process.env.NEXT_PUBLIC_PAYMENT_SERVICE || 'payments',
    SUBSCRIPTION: process.env.NEXT_PUBLIC_SUBSCRIPTION_SERVICE || 'subscription',
    RESUME_PARSER: process.env.NEXT_PUBLIC_RESUME_PARSER_SERVICE || 'resume-parser',
} as const;


export type ServiceModule = keyof typeof ServiceModules;

export type ServiceModuleValue = (typeof ServiceModules)[ServiceModule];
